/**
 * Created by Mattias on 2015-03-16.
 */

define('all/logoutConfirmation',['jquery', 'all/bonusslider'], function ($, bonusslider) {

    'use strict';

    function init(){
        $("#gamepicker").bonusSlider({speed: 500, pause: 3000});
    }

    var logoutConfirmation = {};
    logoutConfirmation.init = init;
    return logoutConfirmation;
});

